import React, { useState } from "react";
import {
  Box,
  Card,
  CardBody,
  Heading,
  FormControl,
  FormLabel,
  Select,
  Input,
  Button,
  Text,
  VStack,
  useToast,
  useTheme,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Modal,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import getAxios from "../../hooks/useAxios";
import { Theme } from "../../theme";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const AddDriver: React.FC = () => {
  const navigate = useNavigate();

  const toast = useToast();
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [locality, setLocality] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);

  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [driver, setDriver] = React.useState<any>({});

  const [isDataFetchingArea, setIsDataFetchingArea] = React.useState(true);
  const [area, setArea] = React.useState<any>([]);

  const {
    isOpen: isConfirmOpen,
    onOpen: onApproveOpen,
    onClose: onConfirmClose,
  } = useDisclosure();

  const getAllDrivers = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all drivers", res.data);
      setDriver(res.data.data[0]);
      if (res.data.pagination?.total === 0) {
        toast({
          title: "No driver found",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        onConfirmClose();
        return;
      }
    } catch (error) {
      console.log("error listing drivers", error);
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsDataFetching(false);
    }
  };

  const findDriver = async () => {
    if (!locality || !mobile) {
      toast({
        title: "All fields are required",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    onApproveOpen();

    await getAllDrivers(
      `/drivers?status=approved&blocked=false&mobile=${mobile}`,
    );
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const data = {
        driving_area: locality,
      };
      console.log("data", data);

      await axios.put(`/drivers/${driver?.id}/area`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      toast({
        title: `Driver added to ${locality}`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setLocality("");
      setMobile("");
      setTimeout(() => {
        onConfirmClose();
        navigate("/area");
      }, 2000);
    } catch (error) {
      console.log("error sending notification", error);
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getArea = async () => {
    setIsDataFetchingArea(true);
    try {
      const res = await axios.get(`/driving-areas`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all admin", res.data?.data);
      setArea(res.data?.data);
    } catch (error) {
      console.log("error listing ad", error);
    } finally {
      setIsDataFetchingArea(false);
    }
  };

  React.useEffect(() => {
    getArea();
  }, []);

  return (
    <Box p={6} maxW="600px" mx="auto">
      <Card shadow="lg" borderRadius="xl">
        <CardBody>
          <Heading size="md" mb={6}>
            Assign Driver Area
          </Heading>

          <VStack spacing={5} align="stretch">
            <FormControl isRequired>
              <FormLabel>Select Area</FormLabel>
              <Select
                value={locality}
                onChange={(e) => setLocality(e.target.value)}
                placeholder={
                  isDataFetchingArea ? "Loading Areas..." : "Select Area"
                }
                isDisabled={isDataFetchingArea}
              >
                {area.map((i: any, n: number) => {
                  return (
                    <option key={n} value={i.name}>
                      {i.name}
                    </option>
                  );
                })}
              </Select>
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Registered Mobile Number</FormLabel>
              <Input
                placeholder="Enter Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </FormControl>

            <Button
              height="3rem"
              style={{
                background: theme.colors.primary.main,
                color: theme.colors.bg.main,
              }}
              isDisabled={!locality || !mobile || isDataFetchingArea}
              onClick={findDriver}
              isLoading={loading}
              loadingText="Finding..."
            >
              <Text sx={{ fontSize: theme.fontSizes.body }}>Find Driver</Text>
            </Button>

            <ConfirmModal
              id={driver?.id}
              onClose={onConfirmClose}
              isOpen={isConfirmOpen}
              approvalLoading={isDataFetching}
              handleAddButton={handleSubmit}
              driverDetails={driver}
              locality={locality}
            />
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default AddDriver;

function ConfirmModal({
  id,
  isOpen,
  onClose,
  handleAddButton,
  approvalLoading,
  driverDetails,
  locality,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Heading size="md" mb={6}>
                Driver found
              </Heading>
            </Box>
            <Box mb={theme.space.xl}>
              <Text variant={"body"}>Name: {driverDetails?.name}</Text>
              <Text variant={"body"}>Mobile No: {driverDetails?.mobile}</Text>
            </Box>

            <Box mb={theme.space.xl}>
              <Text variant={"caption"}>
                Note: This driver will added to {locality}.
              </Text>
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
                isLoading={approvalLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleAddButton(id as string);
                }}
              >
                Add
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
